import { uniq } from 'lodash';

import { AsString, ComputedSeriesExpression } from '@blockworks/platform/api/research/studio';

import { SummaryFn } from '../../utils';

const getExpressionKeys = (expression: ComputedSeriesExpression | string): string[] => {
    if (typeof expression === 'string') return [expression];
    return uniq([...getExpressionKeys(expression.left), ...getExpressionKeys(expression.right)]);
};

const resolveExpression = (expression: ComputedSeriesExpression | string, values: any): number => {
    if (typeof expression === 'string') {
        return values?.[expression];
    }
    const left = resolveExpression(expression.left, values);
    const right = resolveExpression(expression.right, values);
    switch (expression.operator) {
        case '+':
            return left + right;
        case '-':
            return left - right;
        case '*':
            return left * right;
        case '/':
            return left / right;
    }
};

const resolveComputedSeries = <T extends {}>(
    expression: ComputedSeriesExpression<AsString<keyof T>>,
    agg: SummaryFn,
    data: T[],
) => {
    const keys = getExpressionKeys(expression) as (keyof T)[];
    const aggregates = {} as Record<keyof T, number | undefined>;
    keys.forEach(key => {
        aggregates[key] = agg(data, row => {
            if (row[key] === null || row[key] === undefined || isNaN(row[key])) return 0;
            return +row[key] as number;
        });
    });
    const value = resolveExpression(expression, aggregates);
    return value;
};

export { getExpressionKeys, resolveComputedSeries };
